<template>
  <div>
    <!--:http-request="httpRequest"-->
    <el-upload
      :action="url" :headers="headers" :file-list="files" :accept="accept"
      :limit="limit" :auto-upload="autoUpload" :show-file-list="showFileList"
      ref="uploadFiles" :on-exceed="handleExceed" :list-type="listType"
      :data="elseData"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      :on-error="handleError"
      :on-change="handleChange"
      :before-upload="handleBeforeUpload"
      :before-remove="handleBeforeRemove"
      :disabled="disabled">
      <el-button v-if="autoUpload" :disabled="disabled" size="small" type="primary">选择
      </el-button>
      <el-button v-if="!autoUpload" :disabled="disabled" slot="trigger" size="small" type="primary">选择
      </el-button>
      <el-button v-if="!autoUpload" :disabled="disabled" size="small" type="primary"
                 @click="submitUpload">上传
      </el-button>
      <div slot="tip" v-if="tip" class="el-upload__tip" v-html="tip"></div>
    </el-upload>
    <!--<el-dialog :visible.sync="dialogVisible">-->
    <!--<img width="100%" :src="dialogImageUrl" alt="">-->
    <!--</el-dialog>-->

  </div>
</template>

<script>
    import Cookies from "js-cookie";
    import global from "@/utils/global";

    export default {
        name: 'KtUploadFiles',
        props: {
            tip: String,
            elseData: Object,//上传时附带的额外参数
            accept: String,//可接受文件类型
            limit: Number, //最大允许上传个数
            files: Array,  // 文件列表
            handleBeforeUpload: Function, //上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
            disabled: {
                type: Boolean,
                default: false
            },
            headers: {//上传的请求头部
                type: Object,
                default: function () {
                    return {token: Cookies.get('token')}
                }
            },
            url: {
                type: String,
                default: global.baseUrl + "/mAttach/upload"
            }, // 上传地址
            autoUpload: {//是否立即上传
                type: Boolean,
                default: false
            },
            showFileList: {//是否显示已上传文件列表
                type: Boolean,
                default: true
            },
            listType: {
                type: String,
                default: "picture" //text/picture/picture-card //不建议使用picture-card，样式不好看；若想使用，请使用KtPhotoWall组件
            }
        },
        data() {
            return {
                dialogVisible: false,//是否显示图片对话框
                dialogImageUrl: ''//对话框图片地址
            }
        },
        methods: {
            //文件超出个数限制时的钩子
            /**
             * @param files 本次选择的文件数组
             * @param fileList 已存在的文件数组
             */
            handleExceed: function (files, fileList) {
                this.$emit('handleExceed', {files: files, fileList: fileList})
            },
            //点击文件列表中已上传的文件时的钩子
            handlePreview: function (file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
                this.$emit('handlePreview', {file: file})
            },
            //文件列表移除文件时的钩子
            handleRemove(file, fileList) {
                this.$emit('handleRemove', {file: file})
            },
            //文件上传成功时的钩子
            handleSuccess(response, file, fileList) {
                this.$emit('handleSuccess', {response: response, file: file, fileList: fileList})
            },
            //文件上传失败时的钩子
            handleError(err, file, fileList) {
                this.$emit('handleError', {err: err, file: file, fileList: fileList})
            },
            //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
            handleChange: function (file, fileList) {
                if (file.status === 'ready') {
                    file.uuid = "";
                    file.attachId = 0;
                } else if (file.status === 'success') {
                    file.uuid = file.response.data.uuid;
                    file.attachId = file.response.data.id;
                    file.url = file.response.data.savePath;
                }
                this.$emit('handleChange', {file: file, fileList: fileList})
            },

            //删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止上传。
            handleBeforeRemove: function (file, fileList) {
                if (file.status === 'success' && file.attachId !== 0) {
                    return this.$confirm(`确定移除 ${file.name}？`, "提示", {
                        type: "warning"
                    }).then(() => {
                        this.$emit('handleBeforeRemove', {file: file, fileList: fileList});
                    });
                }
            },

            submitUpload: function () {
                this.$refs.uploadFiles.submit();
//      this.$emit('submitUpload');
            }
        },
        mounted() {

        }
    }
</script>
<style scoped>
  .el-dialog {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/views/Core/KtUploadFiles.vue